import { render, staticRenderFns } from "./addGroupDialog.vue?vue&type=template&id=025f90ba&scoped=true&"
import script from "./addGroupDialog.vue?vue&type=script&lang=js&"
export * from "./addGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./addGroupDialog.vue?vue&type=style&index=0&id=025f90ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f90ba",
  null
  
)

export default component.exports